var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4807_246122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 1.3125C7.4375 1.07088 7.24162 0.875 7 0.875C6.75838 0.875 6.5625 1.07088 6.5625 1.3125V6.5625H1.3125C1.07088 6.5625 0.875 6.75838 0.875 7C0.875 7.24162 1.07088 7.4375 1.3125 7.4375H6.5625V12.6875C6.5625 12.9291 6.75838 13.125 7 13.125C7.24162 13.125 7.4375 12.9291 7.4375 12.6875V7.4375H12.6875C12.9291 7.4375 13.125 7.24162 13.125 7C13.125 6.75838 12.9291 6.5625 12.6875 6.5625H7.4375V1.3125Z",
    fill: "#000001"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4807_246122)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#131619"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5e364a0f82130657ce70eddad6b6aecb.svg";
export { ForwardRef as ReactComponent };